import GraphLibAdapter from "./graph-lib-adapter";
import { JagmRawLineSignalData } from "@incartdev/jagm-chart";

export class GraphSplitAdapter extends GraphLibAdapter {
    config;

    constructor(props) {
        super(props);
        this.config = [
            { start: 0, stop: 5 },
            { start: 6, stop: 11 }
        ];
    }

    changeDefaultScaleSettings(scale) {
        const { xScaleIndex, yScaleIndex } = scale;
        const signals = [];
        this.visualSettings.view.canvas.items.forEach(item => {
            item.columns.forEach(item => {
                const signal = item.rows[0].item.content.find(item => item.name === "signals");
                signals.push(signal);
            });
        });

        signals.forEach(item => {
            item.settings.axis.x.scale.currIndex = xScaleIndex;
            item.settings.axis.y.scale.currIndex = yScaleIndex;
        });
    }

    plotData = async signalData => {
        this.chartProvider.signalObjectGroups.forEach(async signalGroup => {
            signalData.forEach(async (item, index) => {
                const preparedSignalData = new JagmRawLineSignalData(item);
                await signalGroup.addSignalData(0, 0, index, preparedSignalData);
            });
        });

        this.visProvider?.refreshGraphics();
    };

    clearGraph = async () => {
        const promises = [];
        for (let signalGroupIndex = 0; signalGroupIndex < this.chartProvider.signalObjectGroups.length; ++signalGroupIndex) {
            const signalGroup = this.chartProvider.signalObjectGroups[signalGroupIndex];
            const config = this.config[signalGroupIndex];
            for (let index = config.start; index <= config.stop; index++) {
                promises.push(signalGroup.clearSignalData(0, 0, index));
            }
        }

        await Promise.all(promises);
    };

    clearMarks = async () => {
        this.chartProvider.charts.forEach(async chart => {
            const marksGroup = chart.findContentGroup("marks");
            await marksGroup.clearMark();
        });
    };

    convertQRSMarksToStructure = marksData => {
        return marksData.map(mark => {
            return {
                type: "QRS",
                data: mark,
                x: this.valueConverter.convertPointsToPixels(mark, this.fd)
            };
        });
    };

    convertRRMarksToStructure = marksData => {
        return marksData.texts.map((text, index) => {
            return {
                type: "RR",
                data: text,
                x: this.valueConverter.convertPointsToPixels(marksData.Xs_pnt[index], this.fd)
            };
        });
    };

    plotMarks = async marksData => {
        this.chartProvider.charts.forEach(async chart => {
            const marksGroup = chart.findContentGroup("marks");
            await marksGroup.addMark({ type: "event", data: marksData });
        });
    };

    setupMarks = async () => {
        this.chartProvider.charts.forEach(chart => {
            const marksGroup = chart.findContentGroup("marks");

            const markAreas = marksGroup.getMarkArea("RR", "text");
            if (markAreas === undefined) return;
            markAreas.forEach(area => {
                area.addDataConverter("RR", data => {
                    if (data !== undefined) {
                        return `${data}`;
                    }
                    return "";
                });
            });
        });
    };
}
